/* eslint-disable promise/avoid-new */
export const getCitationCoordinates = (modelOutput, abstract, sentence, isModelFinished) => {
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('../workers/get-citation-coordinates-worker.js', import.meta.url));

    worker.onmessage = function(e) {
      resolve(e.data);
      worker.terminate();
    };

    worker.onerror = function(error) {
      reject(error);
      worker.terminate();
    };

    worker.postMessage({ modelOutput, abstract, sentence, isModelFinished });
  });
};
/* eslint-enable promise/avoid-new */
